import a from "./index.es242.js";
function r(o) {
  var m = o.sheets, t = o.stickyRowsCount, c = o.stickyColumnsCount;
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mx="http://schemas.microsoft.com/office/mac/excel/2008/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main"><workbookPr/>' + (t || c ? "<bookViews><workbookView/></bookViews>" : "") + "<sheets>" + m.map(function(s) {
    var e = s.id, n = s.name;
    return '<sheet name="'.concat(a(n), '" sheetId="').concat(e, '" r:id="rId').concat(e, '"/>');
  }).join("") + "</sheets><definedNames/><calcPr/></workbook>";
}
export {
  r as default
};
//# sourceMappingURL=index.es209.js.map
